export default "__VITE_ASSET__BMBrpWu8__"